<template>
  <div class="selected-filters" v-if="selectedOptions.length">
    <div class="selected-filters__options">
      <HorizontalScroll
        v-if="horizontalScroll"
        :number-items="selectedOptions.length + 1"
        name="selected-filters"
        prefix-item-id="selected-item"
      >
        <div
          v-for="(option, index) in selectedOptions"
          :key="index"
          class="selected-filters__option"
          :style="`text-wrap:nowrap;`"
          :class="{
            'ml-xs': index != 0,
          }"
          :id="`selected-item-${index}`"
        >
          {{ option.title }}

          <svg
            @click="removeSelectedOption(option)"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            aria-hidden="true"
            focusable="false"
            width="18"
            height="18"
          >
            <path
              d="M13.414,12l6.293-6.293a1,1,0,0,0-1.414-1.414L12,10.586,5.707,4.293A1,1,0,0,0,4.293,5.707L10.586,12,4.293,18.293a1,1,0,1,0,1.414,1.414L12,13.414l6.293,6.293a1,1,0,0,0,1.414-1.414Z"
            ></path>
          </svg>
        </div>
        <div
          class="clear-text"
          :id="`selected-item-${selectedOptions.length}`"
          :style="`text-wrap:nowrap;`"
          @click="removeAllSelectedOption"
        >
          Clear filters
        </div>
      </HorizontalScroll>
      <template v-else>
        <div
          v-for="(option, index) in selectedOptions"
          :key="index"
          class="selected-filters__option"
        >
          {{ option.title }}

          <svg
            @click="removeSelectedOption(option)"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            aria-hidden="true"
            focusable="false"
            width="18"
            height="18"
          >
            <path
              d="M13.414,12l6.293-6.293a1,1,0,0,0-1.414-1.414L12,10.586,5.707,4.293A1,1,0,0,0,4.293,5.707L10.586,12,4.293,18.293a1,1,0,1,0,1.414,1.414L12,13.414l6.293,6.293a1,1,0,0,0,1.414-1.414Z"
            ></path>
          </svg>
        </div>
        <div
          class="selected-filters__clear clear-text"
          @click="removeAllSelectedOption"
        >
          Clear filters
        </div>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import EventBus from '@/services/eventbus'
import {
  EVENT_CHANGE_SELECTED_FILTER,
  EVENT_REMOVE_SELECTED_FILTER,
  EVENT_REMOVE_ALL_SELECTED_FILTER,
} from '@/utils'
import { computed, onBeforeMount, ref } from 'vue'
import HorizontalScroll from './HorizontalScroll.vue'

withDefaults(
  defineProps<{
    horizontalScroll: boolean
  }>(),
  {}
)

let selectedFilters = ref<{ [key: string]: string[] }>({})

const selectedOptions = computed(() => {
  if (!selectedFilters.value) return []
  if (!Object.keys(selectedFilters.value)?.length) return []
  let options: { attribute: string; value: string; title: string }[] = []
  Object.keys(selectedFilters.value)?.forEach((key) => {
    if (selectedFilters.value && selectedFilters.value[key]?.length) {
      selectedFilters.value[key]?.forEach((value) => {
        options = [
          ...options,
          ...[
            {
              attribute: key,
              value,
              title: key.includes('parents')
                ? convertSnakeCaseToTitleCase(value)
                : value,
            },
          ],
        ]
      })
    }
  })
  return options
})

onBeforeMount(() => {
  EventBus.on(EVENT_CHANGE_SELECTED_FILTER, (value) => {
    selectedFilters.value = value
  })
})
function removeSelectedOption(option: { attribute: string; value: string }) {
  EventBus.trigger(EVENT_REMOVE_SELECTED_FILTER, option)
}
function removeAllSelectedOption() {
  EventBus.trigger(EVENT_REMOVE_ALL_SELECTED_FILTER)
}
function convertSnakeCaseToTitleCase(string: string) {
  let formatted = string.replace(/[-_]/g, ' ')
  formatted = formatted.toLowerCase()
  formatted = formatted.charAt(0).toUpperCase() + formatted.slice(1)
  return formatted
}
</script>

<style lang="scss">
.selected-filters {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 1rem;
  margin: 0 0 var(--space-small) 0;
  @include media-md-up {
    flex-direction: row;
  }
  &__options {
    display: flex;
    flex-wrap: wrap;
    white-space: nowrap;
    align-items: baseline;
    gap: 0.5rem;
    width: 100%;
  }
  &__option {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    border: 1px solid var(--border-color);
    border-radius: 2rem;
    background: #e9e9e9;
    font-weight: 500;
    font-size: 13px;
    &:hover {
      background-color: #0e0e0e2e;
    }
    svg:hover {
      cursor: pointer;
    }
  }
  &__clear {
    margin-left: auto;
    min-width: 100px;
    text-align: center;
    padding: 1rem 0 6px 6px;
    @include media-md-up {
      text-align: right;
    }
  }
  .clear-text {
    text-decoration: underline;
    font-weight: 500;
    cursor: pointer;
    margin: auto var(--space-xsmall);
  }
}
</style>
